import { render, staticRenderFns } from "./NoticeRecord.vue?vue&type=template&id=68f951c6&scoped=true"
import script from "./NoticeRecord.vue?vue&type=script&lang=js"
export * from "./NoticeRecord.vue?vue&type=script&lang=js"
import style0 from "./NoticeRecord.vue?vue&type=style&index=0&id=68f951c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f951c6",
  null
  
)

export default component.exports